import BaseMystery from '../BaseMystery'

const SecondGloriousMystery = () => {
	const imagesList = [
		"https://www.wga.hu/art/a/andrea/firenze/spanish/5vault4.jpg",
		"https://www.wga.hu/art/a/andrea/vanni/ascensio.jpg",
		"https://www.wga.hu/art/b/barnaba/fragmen2.jpg",
		"https://www.wga.hu/art/c/campi/vincenzo/ascensio.jpg",
		"https://www.wga.hu/art/g/garofalo/ascensio.jpg",
		"https://www.wga.hu/art/g/ghiberti/various/stained1.jpg",
		"https://www.wga.hu/art/g/giotto/assisi/upper/new_test/02ascens.jpg",
		"https://www.wga.hu/art/g/giotto/padova/3christ/chris22.jpg",
		"https://www.wga.hu/art/g/guarient/ascensio.jpg",
		"https://www.wga.hu/art/j/jacopo/cione/1/3r2_up1.jpg",
		"https://www.wga.hu/art/k/kulmbach/ascensi.jpg",
		"https://www.wga.hu/art/m/mantegna/05/2chapel.jpg",
		"https://www.wga.hu/art/m/mariotto/life9.jpg",
		"https://www.wga.hu/art/m/master/thomas/4garam.jpg",
		"https://www.wga.hu/art/zgothic/mosaics/6sanmarc/2cucros2.jpg",
		"https://www.wga.hu/art/n/niccolo/foligno/predel02.jpg",
		"https://www.wga.hu/art/o/orioli/ascensio.jpg",
		"https://www.wga.hu/art/p/perugino/christ/ascensio.jpg",
		"https://www.wga.hu/art/r/rembrand/12passio/05passio.jpg",
		"https://www.wga.hu/art/r/robbia/andrea/la_verna/5verna.jpg",
		"https://www.wga.hu/art/r/robbia/luca/duomo/6duomo.jpg",
		"https://www.wga.hu/art/t/theophax/ascensio.jpg",
		"https://www.wga.hu/art/t/tintoret/3b/2upper/2/30ascen.jpg",
	];

	const scriptureQuote = "\"Men of Galilee, why are you standing there looking at the sky? This Jesus who has been taken up from you into heaven will return in the same way as you have seen him going into heaven.\"";
	const scriptureCitation = "Acts 1:11 (NABRE)";
	const citationLink = "https://www.biblegateway.com/passage/?search=Acts%201%3A6-11&version=NABRE";

	return (
		<BaseMystery titleText="The Ascension"
				imagesList={imagesList}
				scriptureQuote={scriptureQuote}
				scriptureCitation={scriptureCitation}
				citationLink={citationLink}
				rightHanded={true} />
	);
};

export default SecondGloriousMystery;